import { useState } from 'react';
import { Eye, Edit3, EyeOff, Trash2 } from 'lucide-react';
import { Absensi } from '../../model/Absensi';

export let absens : Absensi[] = [
]

const updateAbsensData = (updatedData = []) => {
  absens.length = 0; // Clear the existing array
  updatedData.forEach((item: any) => {
    absens.push({
      id                    : item.id || 'undefined',
      tanggal               : item.tanggal || '-',
      jam_masuk             : item.jam_masuk || '-',
      jam_keluar            : item.jam_keluar || '-',
      status                : item.status || '-',
      tipe_aktivitas        : item.tipe_aktivitas || '-',
      penyetujuan_aktivitas : item.penyetujuan_aktivitas || '',
      detail_aktivitas      : item.detail_aktivitas || {},
      karyawan              : item.karyawan || item.id_karyawan || ''
    });
  });
}  

const getKaryawanName = (karyawan: any) => {
  if (!karyawan) return '-';
  if (typeof karyawan === 'string') return karyawan;
  return karyawan.nama || karyawan.username || karyawan.id || JSON.stringify(karyawan);
};

export const fetchGetAbsensiAll = async () => {
  let key = process.env.REACT_APP_API_KEY || '';
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", key);

  const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow" as RequestRedirect
  };

  const apiUrl = (process.env.REACT_APP_API_URL + "/bawaslu_phwt/absensi/all")
  const result = await fetch(apiUrl, requestOptions)
      .then((response) => response.json())
      .then((result) => { updateAbsensData(result.data ?? []); return { "status" : result.status, "message" : result.message, data: absens }; })
      .catch((error : any) => { return { "status" : 500, "message" : "Terjadi kesalahan pada server", "error" : error.message , data: []} });
    console.log(result);
    return result;
 }

export const fetchPostAbsensi = async ({ akun } : { akun : any}) => {
  let key = process.env.REACT_APP_API_KEY || '';
  const myHeaders = new Headers();
  myHeaders.append("Authorization", key);

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify(akun),
    redirect: "follow" as RequestRedirect
  };

  const apiUrl = (process.env.REACT_APP_API_URL + "/account");
  return await fetch(apiUrl, requestOptions)
    .then((response) => response.json())
    .then((result) => { return { "status" : result.status, "message" : result.message }; })
    .catch((error) => { return { "status" : 500, "message" : "Terjadi kesalahan pada server", "error" : error.message } });
}

export const fetchPutAbsensi = async ({ id , akun } : { id : string; akun : any}) => {
  let key = process.env.REACT_APP_API_KEY || '';
  const myHeaders = new Headers();
  myHeaders.append("Authorization", key);

  const requestOptions = {
    method: "PUT",
    headers: myHeaders,
    body: JSON.stringify(akun),
    redirect: "follow" as RequestRedirect
  };

  const apiUrl = (process.env.REACT_APP_API_URL + "/account/" + id);
  return await fetch(apiUrl, requestOptions)
    .then((response) => response.json())
    .then((result) => { return { "status" : result.status, "message" : result.message }; })
    .catch((error) => { return { "status" : 500, "message" : "Terjadi kesalahan pada server", "error" : error.message } });
}

export const fetchDeleteAbsensi = async (id : string) => {
  let key = process.env.REACT_APP_API_KEY || '';
  const myHeaders = new Headers();
  myHeaders.append("Authorization", key);

  const requestOptions: RequestInit = {
    method: "DELETE",
    headers: myHeaders,
    redirect: "follow" as RequestRedirect
  };

  const apiUrl = (process.env.REACT_APP_API_URL + "/account/" + id);
  return await fetch(apiUrl, requestOptions)
    .then((response) => response.json())
    .then((result) => { return { "status" : result.status, "message" : result.message }; })
    .catch((error) => { return { "status" : 500, "message" : "Terjadi kesalahan pada server", "error" : error.message } });
}

const getHariFromTanggal = (tanggal: string) => {
  const date = new Date(tanggal);
  if (isNaN(date.getTime())) return tanggal;
  return date.toLocaleDateString('id-ID', { weekday: 'long' });
};

const getWaktuFromTanggal = (tanggal?: string | null) => {
  if (!tanggal) return '-';
  try { return new Date(tanggal).toLocaleTimeString('id-ID', { hour: '2-digit', minute: '2-digit' }) }
  catch (e) { console.error(e); return tanggal }
}

// ==== Badge helpers ====
// Warna badge dikelompokkan berdasarkan makna status, bukan berdasarkan urutan tampil.
const badgeColorMap: { [key: string]: string } = {
  // status kehadiran
  hadir       : 'bg-emerald-50 text-emerald-700 ring-emerald-600/20',
  terlambat   : 'bg-amber-50 text-amber-700 ring-amber-600/20',
  alpa        : 'bg-rose-50 text-rose-700 ring-rose-600/20',
  izin        : 'bg-sky-50 text-sky-700 ring-sky-600/20',
  sakit       : 'bg-violet-50 text-violet-700 ring-violet-600/20',
  cuti        : 'bg-indigo-50 text-indigo-700 ring-indigo-600/20',
  // penyetujuan aktivitas
  approved    : 'bg-emerald-50 text-emerald-700 ring-emerald-600/20',
  disetujui   : 'bg-emerald-50 text-emerald-700 ring-emerald-600/20',
  rejected    : 'bg-rose-50 text-rose-700 ring-rose-600/20',
  ditolak     : 'bg-rose-50 text-rose-700 ring-rose-600/20',
  pending     : 'bg-amber-50 text-amber-700 ring-amber-600/20',
  none        : 'bg-gray-100 text-gray-500 ring-gray-400/20',
  // fallback
  default     : 'bg-gray-100 text-gray-600 ring-gray-500/20',
};

const getBadgeClass = (value?: string | null) => {
  if (!value) return badgeColorMap.default;
  const key = value.toString().trim().toLowerCase();
  return badgeColorMap[key] || badgeColorMap.default;
};

const Badge = ({ value, fallback = '-' }: { value?: string | null; fallback?: string }) => {
  const text = value && value !== '-' ? value : fallback;
  return (
    <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ring-1 ring-inset whitespace-nowrap ${getBadgeClass(value)}`}>
      {text}
    </span>
  );
};

export const RenderTableAbsensi = ({ data, onOpenEdit, onRequestDelete, onRemoveState }: { 
    data: Absensi[] | null; 
    onOpenEdit : (absen: Absensi) => void;
    onRequestDelete?: (absen: Absensi) => void;
    onRemoveState : () => void;
  }) => {
    
    const sorted = (data || []).slice().sort((a, b) => {
      const da = new Date(a.tanggal || 0).getTime();
      const db = new Date(b.tanggal || 0).getTime();
      if (db !== da) return db - da; // newest first
      const ma = a.jam_masuk ? new Date(a.jam_masuk).getTime() : 0;
      const mb = b.jam_masuk ? new Date(b.jam_masuk).getTime() : 0;
      return mb - ma;
    });

    const rows: any[] = [];
    let lastGroup = '';

    if (sorted && sorted.length > 0) {
      for (const absen of sorted) {
        const tanggalOnly = absen.tanggal ? absen.tanggal.split(' ')[0] : '';
        const [y = '', m = '', d = ''] = tanggalOnly.split('-');
        const groupKey = `${y}-${m}-${d}`;
        if (groupKey !== lastGroup) {
          const groupLabel = y && m && d ? new Date(`${y}-${m}-${d}`).toLocaleString('id-ID', {day: '2-digit', month: 'long', year: 'numeric' }) : tanggalOnly;
          rows.push(
            <tr key={`group-${groupKey}`} className="bg-gray-50">
              <td colSpan={4} className="px-6 py-2 text-sm font-semibold text-gray-700">{groupLabel}</td>
            </tr>
          );
          lastGroup = groupKey;
        }

        const jamMasuk = absen.jam_masuk && absen.jam_masuk !== "-" ? new Date(absen.jam_masuk) : null;
        const jamKeluar = absen.jam_keluar && absen.jam_keluar !== "-" ? new Date(absen.jam_keluar) : null;
        const durasiJam = jamMasuk && jamKeluar
          ? Math.floor((jamKeluar.getTime() - jamMasuk.getTime()) / (1000 * 60 * 60))
          : null;
        const jamKeluarAda = jamKeluar !== null;
        const jamMasukText = jamMasuk ? getWaktuFromTanggal(absen.jam_masuk) : '';
        const jamKeluarText = jamKeluar ? getWaktuFromTanggal(absen.jam_keluar) : '';

        rows.push(
          <tr key={absen.id} className="hover:bg-gray-50 transition-colors">
            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
              {getKaryawanName(absen.karyawan)}
            </td>
            <td className="px-6 py-4 whitespace-nowrap">
              <div className="text-sm text-gray-900">{getHariFromTanggal(absen.tanggal)} <Badge value={jamKeluarAda ? (absen.status ?? undefined) : undefined} fallback="Berlangsung" /></div>
              <div className="text-xs text-gray-500 mt-0.5">
                {jamMasukText}{jamKeluarText ? ` – ${jamKeluarText}` : ''}
                {jamKeluarText && (
                  <span className="text-gray-400"> &middot; {durasiJam} jam</span>
                )}
              </div>
            </td>
            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
              <div className="flex flex-wrap items-center gap-1.5">
                <Badge value={absen.tipe_aktivitas} />
                {absen.penyetujuan_aktivitas !== 'none' && absen.detail_aktivitas && (
                  <Badge value={absen.penyetujuan_aktivitas} fallback="none" />
                )}
              </div>
            </td>
            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
              <div className="flex space-x-2">
                <button onClick={() => { onOpenEdit(absen) }} className="text-green-600 hover:text-green-900 hover:bg-green-50 p-1.5 rounded-md transition-colors" title="Edit">
                  <Edit3 className="w-4 h-4" />
                </button>
                <button
                  onClick={ async () => { try{ if (onRequestDelete) { onRequestDelete(absen); } else { if(window.confirm(`Yakin hapus ${getKaryawanName(absen.karyawan)} - ${absen.tanggal} ?`)) { await fetchDeleteAbsensiRecord(absen?.id); } onRemoveState(); } } catch (err) { console.error("Gagal hapus:", err); } } }
                  className="text-red-600 hover:text-red-900 hover:bg-red-50 p-1.5 rounded-md transition-colors" title="Hapus">
                  <Trash2 className="w-4 h-4" />
                </button>
              </div>
            </td>
          </tr>
        );
      }
    }

    if (rows.length === 0) {
      return (
        <>
          <tr>
            <td colSpan={4} className="text-center py-4 text-gray-500">
              Tidak ada data
            </td>
          </tr>
        </>
      );
    }

    return <>{rows}</>;
}

export const fetchPutAbsensiRecord = async ({ id, payload } : { id: string; payload: any }) => {
  let key = process.env.REACT_APP_API_KEY || '';
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", key);

  const requestOptions = {
    method: "PUT",
    headers: myHeaders,
    body: JSON.stringify(payload),
    redirect: "follow" as RequestRedirect
  };

  const apiUrl = (process.env.REACT_APP_API_URL + "/bawaslu_phwt/absensi/put/" + id);
  return await fetch(apiUrl, requestOptions)
    .then((response) => response.json())
    .then((result) => { return { "status" : result.status, "message" : result.message }; })
    .catch((error) => { return { "status" : 500, "message" : "Terjadi kesalahan pada server", "error" : error.message } });
}

export const fetchDeleteAbsensiRecord = async (id : string) => {
  let key = process.env.REACT_APP_API_KEY || '';
  const myHeaders = new Headers();
  myHeaders.append("Authorization", key);

  const requestOptions: RequestInit = {
    method: "DELETE",
    headers: myHeaders,
    redirect: "follow" as RequestRedirect
  };

  const apiUrl = (process.env.REACT_APP_API_URL + "/bawaslu_phwt/absensi/delete/" + id);
  return await fetch(apiUrl, requestOptions)
    .then((response) => response.json())
    .then((result) => { return { "status" : result.status, "message" : result.message }; })
    .catch((error) => { return { "status" : 500, "message" : "Terjadi kesalahan pada server", "error" : error.message } });
}